import EditRecipientAddress from './EditRecipientAddress';

export default EditRecipientAddress;
